"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextFormStatus = void 0;
const form_1 = require("../types/form");
const getNextFormStatus = (currentStatus, action) => {
    switch (action) {
        case form_1.FormAction.EDIT: {
            if ([
                form_1.FormStatus.INIT,
                form_1.FormStatus.VALID,
                form_1.FormStatus.INVALID,
                form_1.FormStatus.SUBMIT_SUCCESS,
                form_1.FormStatus.SUBMIT_FAILED,
            ].includes(currentStatus)) {
                return form_1.FormStatus.DIRTY;
            }
            break;
        }
        case form_1.FormAction.VALIDATE: {
            if ([
                form_1.FormStatus.INIT,
                form_1.FormStatus.DIRTY,
                form_1.FormStatus.VALID,
                form_1.FormStatus.INVALID,
                form_1.FormStatus.SUBMIT_SUCCESS,
                form_1.FormStatus.SUBMIT_FAILED,
            ].includes(currentStatus)) {
                return form_1.FormStatus.VALIDATING;
            }
            break;
        }
        case form_1.FormAction.SUBMIT: {
            if ([form_1.FormStatus.VALID, form_1.FormStatus.SUBMIT_SUCCESS, form_1.FormStatus.SUBMIT_FAILED].includes(currentStatus)) {
                return form_1.FormStatus.SUBMITTING;
            }
            break;
        }
        case form_1.FormAction.SUCCESS: {
            if (currentStatus === form_1.FormStatus.VALIDATING) {
                return form_1.FormStatus.VALID;
            }
            if (currentStatus === form_1.FormStatus.SUBMITTING) {
                return form_1.FormStatus.SUBMIT_SUCCESS;
            }
            break;
        }
        case form_1.FormAction.FAIL: {
            if (currentStatus === form_1.FormStatus.VALIDATING) {
                return form_1.FormStatus.INVALID;
            }
            if (currentStatus === form_1.FormStatus.SUBMITTING) {
                return form_1.FormStatus.SUBMIT_FAILED;
            }
            break;
        }
        default:
            break;
    }
    return currentStatus;
};
exports.getNextFormStatus = getNextFormStatus;
